// extracted by mini-css-extract-plugin
module.exports = {"challenge":"Challenge_challenge__zTWxo","timeline":"Challenge_timeline__3E6b_","edit":"Challenge_edit__2Fhse","content":"Challenge_content__3vhie"};